import { ethers } from "ethers";
import {
 STAGES_PRESALE
} from "../utils/constants";
import { useWallet } from "../context/WalletContext";
import { useEffect } from "react";




export const calculateStageProgress = (tokenSold: number) => {
  let remaining = tokenSold;
  return STAGES_PRESALE.map((stage) => {
    if (remaining <= 0) return 0;
    if (remaining >= stage.tokenRemain) {
      remaining -= stage.tokenRemain;
      return 100;
    } else {
      const percent = (remaining / stage.tokenRemain) * 100;
      remaining = 0;
      return percent;
    }
  });
};


